import React, { useRef, useState } from "react";
import { colors, fonts, mediaQueriesNumbers, useMediaQuery, frames, glyphs, css } from "../../Styles";
import { Button, NewInputList, NewInputListHandles, NewModal, MainContentPaddingTypes } from "..";
import { ButtonTypes, ListStyle_Types } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { useUser } from "../../Services"

interface resetPasswordProps {
  ifSucces: () => void
}

export default function ResetPasswordModal({ifSucces}:resetPasswordProps) {
  const {t} = useTranslation()
  const {tokenResetPassword} = useUser()
  const inputRef = useRef<NewInputListHandles>(null); 
  const [message, setMessage] = useState<string|null>(null)
  const mobile = useMediaQuery(`(max-width: ${mediaQueriesNumbers.mobileMax}px)`);  

  // Use "Enter" to submit
  onkeydown = (event) => {
    if (event.code === "Enter") {
      ResetPasswordAction()
    }
  }

  const ResetPasswordAction = () => {
    if (inputRef && inputRef.current) {
      if (inputRef.current.refs && inputRef.current.refs.current) {
        const token = inputRef.current.refs.current[0].value
        const Password = inputRef.current.refs.current[1].value
        const secondPassword = inputRef.current.refs.current[2].value
        if(!token) {
          inputRef.current.refs.current[0].setError()
        }
        else if (!Password || secondPassword !== Password) {
          inputRef.current.refs.current[1].setError()
        }
        else {
          tokenResetPassword(token as string, Password as string).then(success => {
            if (success) ifSucces()
              else setMessage(t("loginFlow.resetPassword.newPasswordFail", {defaultValue: "Failed to create new password"}))
            }).catch(err => {
              setMessage(t("loginFlow.resetPassword.newPasswordFail", {defaultValue: "Failed to create new password"}))
            })
          }
          setTimeout(() => {
            setMessage(null);
          }, 2000);
        }
      }
    }

  return (
    <frames.DecorBg>      
      <NewModal
        modalState
        header={t("loginFlow.login.resetPassword", {defaultValue: "Reset Password"})}
        overrides={{ 
          mainContentPadding: MainContentPaddingTypes.secondary,
          overlayColor: colors.blackPrimary+"99"
        }}
        mainContent={
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", width: mobile? "280px" : "fit-content"}}>
            {/* A code has been sent */}
            <p style={{ ...fonts.paragraph, ...fonts.textShadow, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center", whiteSpace: 'pre-wrap', maxWidth: "280px" }}>
              {t("loginFlow.resetPassword.text", {defaultValue: "Text not found"})}           
            </p>
            <NewInputList ref={inputRef}
              startEnhancers={[glyphs.Password({}), glyphs.Password({}), glyphs.Password({})]}
              placeholders={[t("loginFlow.resetPassword.temporaryCode", {defaultValue: "Temporary Code"}), t("loginFlow.resetPassword.newPassword", {defaultValue: "New Password"}), t("loginFlow.resetPassword.repeatPassword", {defaultValue: "Repeat new Password"})]}
              valueOverrides={{
                valueTypes: ["string", "password", "password"]
              }}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px"
              }}
            />
            {/* Create new password button */}
            <Button content={t("loginFlow.resetPassword.createNewPassword", {defaultValue: "Create new Password"})} onClick={ResetPasswordAction}
              buttonType={ButtonTypes.primaryButton}
              overrides={{
                baseButton: {...css.button_FitContent}
              }}
            />
            {/* Contact Support */}
            <div style={{marginTop: "10px", display: "flex", alignItems: "center", flexDirection: "column"}}>
              <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center", marginBottom: "5px" }}>{`${t("loginFlow.resetPassword.noPasswordRevieved", {defaultValue: "Didn't recieve a temporary code"})}?`}</p>
              <Button
                content={t("loginFlow.resetPassword.contactSupport", {defaultValue: "Contact Support"})} 
                onClick={() => window.location.href = 'mailto:support@agrisys.dk'}
                buttonType={ButtonTypes.textButton}
                overrides={{
                  baseButton: {...css.button_TextUnderline}
                }}
              />
              <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center", marginTop: "2px" }}>support@agrisys.dk</p>
            </div>
            {message && <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, position: "absolute", top: mobile? "360px" : "370px" }}>{message}</p>}
          </div>
        }
      />
    </frames.DecorBg>
  )
}